import {
	EnhancedDropDownRHFWithLabel,
	ITest,
	LabelPosition,
	RHookFormMaskedTextField,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useState } from "react";
import { Grid, useMediaQuery, useTheme } from "@mui/material";

import { RHookFormMaskedTextFieldWithVerifyLabel } from "../../RHookFormMaskedTextFieldWithVerifyLabel";

interface IEmployeeBankSetupFieldsPanel extends ITest {
	isAdminUser: any;
	setSelectedSplit: (value: number) => void
	formMethods: any
	onVerifyBankClickedHandler: () => void;
	employeeDDL: any
	onEmployeeSelectionChangeHandler: (selected: any) => void

}
export const EmployeeBankSetupFieldsPanel: FC<
	IEmployeeBankSetupFieldsPanel
> = ({ isAdminUser, setSelectedSplit, formMethods, onVerifyBankClickedHandler, employeeDDL, onEmployeeSelectionChangeHandler }) => {
	// RESPONSIVE
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen;
	// const [selectedSplit, setSelectedSplit] = useState(100);
	const onSPlitSelectionChangeHandler = (e: any) => {
		// alert(e.value);
		setSelectedSplit(e.value);
		if (e.value === 200) {
			formMethods.setValue("percenagePerDollorInAcc1", undefined)
		}

	};
	return (
		<>
			{mobileTabOrSmallLaptopScreen && <EnhancedDropDownRHFWithLabel
				label="Load Employee"
				selectName="employee"
				testId={`employee`}
				labelPosition={LabelPosition.Top}
				items={employeeDDL ?? []}
				onSelectionChangeHandler={onEmployeeSelectionChangeHandler}
				showEmpty
			/>}
			<RHookFormTextFieldWithLabel
				id="employeeName"
				testId={`account-1-Name`}
				label="Employee Name"
				labelPosition={LabelPosition.Top}
				readOnly

			/>
			<RHookFormTextFieldWithLabel
				id="account1Name"
				testId={`account-1-Name`}
				label="Bank Name"
				labelPosition={LabelPosition.Top}

			/>
			{/* <RHookFormMaskedTextFieldWithLabel
					id="account1No"
					testId={`accountNo`}
					placeholder={"000000000000000000"}
					inputMaskPattern={"000000000000000000"}
					label="Bank Account No."
					labelPosition={LabelPosition.Top}
				/> */}
			<RHookFormMaskedTextFieldWithVerifyLabel
				id="account1No"
				testId={`account1No`}
				placeholder={"000000000000000000"}
				inputMaskPattern={"000000000000000000"}
				label={
					<>
						<Grid> Bank Account No.&nbsp;
							<span style={{ color: theme.palette.primary.light, cursor: "pointer" }} onClick={onVerifyBankClickedHandler}>
								[Verify]
							</span>
						</Grid>
					</>
				}
			/>
			<RHookFormMaskedTextFieldWithLabel
				id="branchTransitNoAccount1"
				testId="Branch-Transit-Number"
				inputMaskPattern="00000"
				placeholder="5 Digits"
				label="Branch / Transit No."
			/>
			<RHookFormMaskedTextFieldWithLabel
				id="bankFinancialNoAccount1"
				testId="Branch-Finacial-Number"
				inputMaskPattern={"0000"}
				placeholder={"4 Digits"}
				label="Bank / Fin Institution No."
				labelPosition={LabelPosition.Top}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="split"
				label="Split"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Split-list`}
				items={[
					{ label: "No Split", value: 200 },
					{ label: "Percentage", value: 300 },
					{ label: "Fixed Amount", value: 100 },
				]}
				selectedItem={200}
				labelColumns={4.1}
				fieldColumns={7.9}
				onSelectionChangeHandler={onSPlitSelectionChangeHandler}
			/>
		</>
	);
};
